import { CryptoContext } from '../base';
import { NanoConfigDumpArgs, NanoConfigLoadArgs } from './args';
import { NanoConfigV1 } from './v1';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';
import { NanoConfigV2, NanoConfigV3 } from './v2_v3';

export let NANO_CRYPTO_CONTEXT = new CryptoContext<NanoConfigLoadArgs, NanoConfigDumpArgs>([
  new NanoConfigV1(CU_ANNULLED_BY_PQC_ML),
  new NanoConfigV2(CU_PQC_ML),
  new NanoConfigV3(CU_PQC_ML),
]);
